import * as types from '../mutations'
import Vue from 'vue'
import axios from 'axios'

const state = {
    buses: [],
    routes: [],
}

const mutations = {

    [types.TRACKER_SET_BUSES] (state, data)
    {
        state.buses = data
    },

    [types.TRACKER_SET_ROUTES] (state, data)
    {
        state.routes = data
    },

}

const actions = {

    trackerBusesFetch({commit})
    {
        return new Promise(async(resolve, reject) => {
            const list = await axios.get(process.env.API_URL + '/v1/admin/buses')
            if (list)
            {
                commit(types.TRACKER_SET_BUSES, list.data)
                resolve(list.data)
            } else {
                reject()
            }
        })
    },

    trackerRoutesFetch({commit})
    {
        return new Promise(async(resolve, reject) => {
            const list = await axios.get(process.env.API_URL + '/v1/admin/routes')
            if (list)
            {
                commit(types.TRACKER_SET_ROUTES, list.data)
                resolve(list.data)
            } else {
                reject()
            }
        })
    },

}

const getters = {
    buses: state => JSON.parse(JSON.stringify(state.buses)),
    routes: state => JSON.parse(JSON.stringify(state.routes)),
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/tracker.js